export const status_bar = (t) => ({
	STATUS_BAR_COPY: {
		value: t('common.good_luck'),
		config: {
			fill: '#B3B2DE',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	STATUS_BAR_RESULT: {
		value: '',
		config: {
			fill: '#B3B2DE',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	STATUS_BAR_COUNT: {
		value: '',
		config: {
			fill: '#E43287',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	STATUS_BAR_WIN_LABEL: {
		value: t('bonus.win'),
		config: {
			fill: '#D0DEB2',
			fontFamily: 'Poppins SemiBold',
			fontSize: 16
		}
	},
	STATUS_BAR_WIN_VALUE: {
		value: '0',
		config: {
			fill: '#69AB15',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			align: 'right'
		}
	},
	STATUS_BAR_BALANCE_LABEL: {
		value: t('common.balance'),
		config: {
			fill: '#B3B2DE',
			fontFamily: 'Poppins SemiBold',
			fontSize: 16,
			align: 'right'
		}
	},
	STATUS_BAR_BALANCE_VALUE: {
		value: '',
		config: {
			fill: '#69AB15',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	}
});
